export class NonExistentUserError extends Error {
	public constructor(message?: string) {
		super(message);
	}
}
